// extracted by mini-css-extract-plugin
module.exports = {"timeContainer":"SchemaListItem_timeContainer_zz-9Y","isToday":"SchemaListItem_isToday_3cxYR"};